import {ALL_POOLS} from "../actionTypes/pool.action-types";

export const setPools = ( pools ) => {
    return {
        type: ALL_POOLS,
        payload: pools
    }
};
